/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAOffIcon24Solid = forwardRef('MediaAudioVolumeAOffIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.884 1.616a1.25 1.25 0 1 0-1.768 1.768L5.732 7H5.5A2.5 2.5 0 0 0 3 9.5v5A2.5 2.5 0 0 0 5.5 17h3.745l5.27 4.587c.97.845 2.485.156 2.485-1.131v-2.188l3.116 3.116a1.25 1.25 0 0 0 1.768-1.768l-18-18Z" }),
        React.createElement("path", { d: "M17 3.544v8.128l-6.107-6.107 3.622-3.152C15.485 1.568 17 2.257 17 3.544Z" })));
});
